import type { TourDefinition } from '../types';

export const companyProfileTour: TourDefinition = {
  id: 'company-profile',
  title: 'Perfil da Empresa',
  steps: [
    {
      element: '[data-tour="company-action-buttons"]',
      popover: {
        title: 'Ações',
        description:
          'Veja os leads vinculados ou edite as informações da empresa.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="company-tabs"]',
      popover: {
        title: 'Abas de Informação',
        description:
          'Alterne entre Visão Geral, Leads, Atividades e Estatísticas.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="company-info-card"]',
      popover: {
        title: 'Dados da Empresa',
        description:
          'Segmento, setor, porte, localização e descrição da empresa.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '[data-tour="company-contact-card"]',
      popover: {
        title: 'Contato',
        description:
          'Website, email e telefone da empresa. Clique para interagir.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="company-quick-actions"]',
      popover: {
        title: 'Ações Rápidas',
        description:
          'Adicione leads, agende reuniões ou envie emails diretamente.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
